<template lang="pug">
  v-container(v-if="isOrderEntity")
    h2.primary--text {{ $tc('Order._name', 1) }}
      g-data-table(
        :headers="responsibilityHeaders",
        :items="instanceResponsibilities",
      )
      h2.primary--text {{ $tc('OrderLine._name', 1) }}
      g-data-table(
        :headers="responsibilityHeaders",
        :items="orderOrderLineResponsibilities",
      )
  v-container(v-else)
    h2.primary--text {{ $tc('Order.responsibilities', 1) }}
      g-data-table(
        :headers="responsibilityHeaders",
        :items="instanceResponsibilities",
      )
</template>
<script>
import EntityMixin from '@/mixins'

export default {
  mixins: [EntityMixin],
  name: 'entity-add',
  allResp: [],
  props: ['path', 'entity', 'parentInstance'],
  data: () => ({}),
  computed: {
    responsibilityHeaders() {
      return [
        { text: this.$t('Order.externalId'), value: "parentEntity.externalId" },
        { text: this.$t('Responsibility.process'), value: "process.name" },
        { text: this.$t('Responsibility.task'), value: "task.name" },
        { text: this.$t('Responsibility.taskType'), value: "task.type" },
        { text: this.$t('Responsibility.state'), value: "state" },
        { text: this.$t('Responsibility.deadLine'), value: "deadLine", type: "DateTime"  },
        { text: this.$t('Responsibility.finishedAt'), value: "finishedAt", type: "DateTime" },
        { text: this.$t('Responsibility.responsable'), value: "responsable.fullName" },
      ];
    },
    errors(){
     return this.$store.state.errors;
    },
    orderOrderLineResponsibilities() {
      if(this.parentInstance.orderLinesResponsibilities!= null){
        return this.parentInstance.orderLinesResponsibilities.map(resp => ({ ...resp, parentEntity: { externalId: resp.orderLine.externalId }}))
      }
    },
    instanceResponsibilities() {
      if(this.instance != null){
        return [...this.instance.map(resp => ({ ...resp, parentEntity: { externalId: _.get(this.parentInstance, 'externalId') }}))];
      }
    },
    isOrderEntity() {
      return this.$route.path.includes('/Order/')
    }
  }
}
</script>
